import { computed } from 'vue';

import store from '@/study-search/store';
import { ParameterType } from '@/study-search/enums';
import EventsSender from '../../../infrastructure/events/EventsSender';
import { PageTitleConstructor } from '@/study-search/models/page-title';

export default class NoResults {
	private readonly pageTitleConstructor = new PageTitleConstructor();

	public readonly MAX_NUMBER_OF_RESULTS_FOR_SUGGESTIONS = 6;
	public readonly dataIdentifier = 'search-recommendations';

	public selectedDiscipline = computed((): string => {
		return store.getters.getFilterValues(ParameterType.DISCIPLINES)[0];
	});

	public countryFilterValues = computed((): string[] => {
		return store.getters.getFilterValues(ParameterType.COUNTRY);
	});

	public mounted(): void {
		EventsSender.initializeRecommendations(this.dataIdentifier);
		EventsSender.subscribeToRecommendationsEvents(this.dataIdentifier);
	}

	public pageTitle = computed((): string => {
		return this.pageTitleConstructor.getPageTitle();
	});

	public resultsCount = computed((): number => {
		return store.getters.getTotalSearchResults();
	});
}
